import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { vRequired, vEmail } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import SelectPretty from 'components/Input/SelectPretty/SelectPretty'
import { Input } from 'components/Input/Input'

const options = [
  {
    name: '#',
    value: '#',
  },
  {
    name: '*',
    value: '*',
  },
]

const beepOptions = [
  {
    name: 'Yes',
    value: true,
  },
  {
    name: 'No',
    value: false,
  },
]

const transcribeOptions = [
  {
    name: 'Yes (10c/min)',
    value: true,
  },
  {
    name: 'No',
    value: false,
  },
]

export default class RecordForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Start recording the call. This can be used to record either an entire call flow or just a
          simple voicemail.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <Field
          label="Finish recording on key"
          name="finishOnKey"
          component={SelectPretty}
          options={options}
          validate={[vRequired]}
        />
        <Field
          label="Play Beep"
          name="playBeep"
          component={SelectPretty}
          info="Play a beep before the recording starts"
          options={beepOptions}
          validate={[vRequired]}
        />
        <Field
          label="Notification email"
          name="notificationEmail"
          component={Input}
          info="Optionally, send an email to notify you of each recording. If empty, no emails will be sent."
          validate={[vEmail]}
        />
        <Field
          label="Transcribe voice to text"
          name="transcribe"
          component={SelectPretty}
          options={transcribeOptions}
          validate={[vRequired]}
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Record/RecordForm.jsx